import { toast } from "react-toastify";
import { SET_NET_PULSE_DATA, SET_ORGANIZATIONS_LOADING, SET_DEVICES_LOADING, } from "./types";
function parseApiResponse(response) {
    return response?.data ?? response;
}
function isForbidden(error) {
    const err = error;
    return (err.response?.status === 403 ||
        err.statusCode === 403 ||
        String(err.message ?? "")
            .toLowerCase()
            .includes("forbidden"));
}
/**
 * Creates NetPulse action creators that use the provided apiHandler.
 * Allows dashboard and admin-portal to share the same logic with their own API client.
 */
export function createNetPulseActions(apiHandler) {
    const fetchOrganizations = () => async (dispatch) => {
        try {
            dispatch({ type: SET_ORGANIZATIONS_LOADING, payload: true });
            const response = await apiHandler("get", "/net-pulse/organizations");
            const data = parseApiResponse(response);
            if (!data) {
                toast.error("Invalid response from server. Please try again.");
                throw new Error("Invalid response from server");
            }
            dispatch({
                type: SET_NET_PULSE_DATA,
                payload: { organizations: Array.isArray(data) ? data : [] },
            });
        }
        catch (error) {
            console.error("[fetchOrganizations] Error:", error);
            toast.error("Failed to load organizations. Please try again.");
            throw error;
        }
        finally {
            dispatch({ type: SET_ORGANIZATIONS_LOADING, payload: false });
        }
    };
    const fetchDevices = (organizationId) => async (dispatch) => {
        try {
            dispatch({ type: SET_DEVICES_LOADING, payload: true });
            const response = await apiHandler("get", `/net-pulse/organizations/${organizationId}/devices`);
            const data = parseApiResponse(response);
            if (!data) {
                toast.error("Invalid response from server. Please try again.");
                throw new Error("Invalid response from server");
            }
            dispatch({
                type: SET_NET_PULSE_DATA,
                payload: { devices: Array.isArray(data) ? data : [] },
            });
        }
        catch (error) {
            console.error("[fetchDevices] Error:", error);
            if (isForbidden(error)) {
                dispatch({ type: SET_NET_PULSE_DATA, payload: { devices: [] } });
                toast.error("You do not have access to this organization or its devices.");
            }
            else {
                toast.error("Failed to load devices. Please try again.");
            }
            throw error;
        }
        finally {
            dispatch({ type: SET_DEVICES_LOADING, payload: false });
        }
    };
    const fetchDevice = (organizationId, deviceId) => async (dispatch) => {
        try {
            const response = await apiHandler("get", `/net-pulse/organizations/${organizationId}/devices/${deviceId}`);
            const data = parseApiResponse(response);
            if (!data) {
                toast.error("Invalid response from server. Please try again.");
                throw new Error("Invalid response from server");
            }
            dispatch({
                type: SET_NET_PULSE_DATA,
                payload: { device: data },
            });
        }
        catch (error) {
            console.error("[fetchDevice] Error:", error);
            if (isForbidden(error)) {
                dispatch({ type: SET_NET_PULSE_DATA, payload: { device: {} } });
                toast.error("You do not have access to this organization or device.");
            }
            else {
                toast.error("Failed to load device details. Please try again.");
            }
            throw error;
        }
    };
    return {
        fetchOrganizations,
        fetchDevices,
        fetchDevice,
    };
}
